import React, { useContext, useEffect } from "react"
import { EditorInfoContext } from "../../../../../../../utils/userInfoContext"
import { getNormalizedDimensions } from "../../../../../../../utils/helper";
import { shownNumber } from "./sectionSummaries";

const PositionSection = ({ tool, handleChange, errorState, zoom, showSize = true, children }) => {
    const { setGeo, pageDimensions } = useContext(EditorInfoContext)

    useEffect(() => {
        setGeo(getNormalizedDimensions(tool?.geometry, zoom?.value, pageDimensions))
    }, [])

    if (!showSize) {
        return (
            <div className="pv-pos-row">
                {children}
                <label className="pv-pos-field">
                    <span>X</span>
                    <input
                        type="number"
                        name="geometry.left"
                        value={shownNumber(tool?.geometry?.left)}
                        onChange={handleChange}
                        onFocus={(e) => e.target.select()}
                    />
                </label>
                <label className="pv-pos-field">
                    <span>Y</span>
                    <input
                        type="number"
                        name="geometry.top"
                        value={shownNumber(tool?.geometry?.top)}
                        onChange={handleChange}
                        onFocus={(e) => e.target.select()}
                    />
                </label>
            </div>
        )
    }

    return (
        <>
            <div className="position-section d-flex align-items-center justify-content-between">
                <label className="img-lab-clr">POSITION</label>
                <div className="d-flex position-left-right">
                    <div className="me-3 ">
                        Left: <input
                            type="number"
                            name="geometry.left"
                            value={shownNumber(tool?.geometry?.left)}
                            onChange={handleChange}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                    <div className="top-left-pop">
                        Top:  <input
                            type="number"
                            name="geometry.top"
                            value={shownNumber(tool?.geometry?.top)}
                            onChange={handleChange}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                </div>
            </div>
            {showSize && <div className="size-section d-flex justify-content-between align-items-center cursor-pointer">
                <label className="const-pro img-lab-clr" htmlFor="geometry.keep_proportions">
                   CONSTRAIN PROPORTIONS 
                    <input
                        id="geometry.keep_proportions"
                        type="checkbox"
                        name='geometry.keep_proportions'
                        value={tool?.geometry?.keep_proportions}
                        checked={tool?.geometry?.keep_proportions}
                        onChange={handleChange}
                    />
                </label>
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center const-width">
                        <div>
                            Width:  <input
                                type="number"
                                name="geometry.width"
                                value={shownNumber(tool?.geometry?.width)}
                                onChange={handleChange}
                                onFocus={(e) => e.target.select()}
                            />
                        </div>
                        <div>
                            Height:  <input
                                type="number"
                                name="geometry.height"
                                value={shownNumber(tool?.geometry?.height)}
                                 onChange={handleChange}
                                onFocus={(e) => e.target.select()}
                            />
                        </div>
                    </div>
                    <p className="text-danger">{errorState?.dimensionError}</p>
                </div>
            </div>}
        </>
    )
}
export default PositionSection